<template>
  <div>
    <b-card-title class="data-form pl-3 pt-4"> {{ titleDetalle }}</b-card-title>
    <div>
      <b-row>
        <b-col lg="12" md="12" class="mt-2">
          <b-card>
            <b-card-body>
              <b-row class="pl-4 pr-4 pt-3 pb-3">
                <b-col lg="6" md="6">
                  <label class="label-form" for="desCliente">{{ $t("label.cliente") }}</label>
                  <span class="data-form" id="desCliente">
                    {{ ofertaDemanda.clientexdel.cliente.desCliente }}
                  </span>
                </b-col>
                <b-col lg="4" md="4">
                  <label class="label-form" for="desDelegacion">{{ $t("label.delegacion") }}</label>
                  <span class="data-form" id="desDelegacion">{{
                    ofertaDemanda.clientexdel.delegacion.desDelegacion
                  }}</span>
                </b-col>
                <b-col lg="2" md="2">
                  <label class="label-form" for="divisa">{{ $t("label.divisa") }}</label>
                  <span class="data-form" id="divisa">
                    {{ ofertaDemanda.divisa.simbolo }} {{ ofertaDemanda.divisa.codDivisa }}
                  </span>
                </b-col>
              </b-row>
              <delegaciones-opcionales
                :oferta-demanda="ofertaDemanda"
                v-if="ofertaDemanda.ubicaciones && ofertaDemanda.ubicaciones.length > 1"
              />
              <b-row v-if="ofertaDemanda.transportadora" class="pl-4 pr-4 pb-3">
                <b-col lg="6" md="6">
                  <label class="label-form" for="desTransportadora">{{
                    $t("label.transportadora")
                  }}</label>
                  <span class="data-form" id="desTransportadora">
                    {{ ofertaDemanda.transportadora.descripcion }}
                  </span>
                </b-col>
              </b-row>
              <b-row class="pl-4 pr-4 pb-3">
                <b-col lg="6" md="6">
                  <label class="label-form" for="fecExpirar">{{
                    $t("label.fecha.expiracion")
                  }}</label>
                  <span class="data-form" id="fecExpirar">{{
                    filterDate(ofertaDemanda.fecExpirar)
                  }}</span>
                </b-col>
                <b-col lg="4" md="4">
                  <label class="label-form" for="horaExpiracion">
                    {{ $t("label.hora.expiracion") }}
                  </label>
                  <span class="data-form" id="horaExpiracion">
                    {{ filterTime(ofertaDemanda.fecExpirar) }}
                  </span>
                </b-col>
                <b-col>
                  <label class="label-form" for="coste">{{ $t("label.coste") }}</label>
                  <span class="data-form" id="coste">
                    {{ $t(`label.coste.${ofertaDemanda.coste.codParametro}`) }}
                  </span>
                </b-col>
              </b-row>
              <b-row v-if="isShowBankField" class="pl-4 pr-4 pb-3">
                <b-col>
                  <label class="label-form" for="cuentaCorriente">
                    {{ $t("label.cuenta_corriente") }}
                  </label>
                  <span class="data-form" id="cuentaCorriente">
                    {{ ofertaDemanda.cuentaCorriente }}
                  </span>
                </b-col>
                <b-col>
                  <label class="label-form" for="agNumeroSucursal">
                    {{ $t("label.ag_numero_sucursal") }}
                  </label>
                  <span class="data-form" id="agNumeroSucursal">
                    {{ ofertaDemanda.agNumeroSucursal }}
                  </span>
                </b-col>
              </b-row>
              <b-row v-if="isShowBankField" class="pl-4 pr-4 pb-3">
                <b-col>
                  <label class="label-form" for="cnpjPersona">
                    {{ $t("label.cnpj_persona") }}
                  </label>
                  <span class="data-form" id="cnpjPersona">
                    {{ ofertaDemanda.cnpjPersona }}
                  </span>
                </b-col>
                <b-col>
                  <label class="label-form" for="ispbBanco">
                    {{ $t("label.ispb_banco") }}
                  </label>
                  <span class="data-form" id="ispbBanco">
                    {{ ofertaDemanda.ispbBanco }}
                  </span>
                </b-col>
              </b-row>
              <b-row class="pl-4 pr-4 pb-3">
                <b-col lg="6" md="6" v-if="ofertaDemanda.checkParcial != undefined">
                  <label class="label-form" for="checkParcial">{{ $t("label.parcial") }}</label>
                  <span class="data-form" id="checkParcial" v-if="ofertaDemanda.checkParcial">
                    {{ $t("label.si") }}
                  </span>
                  <span class="data-form" id="checkParcial" v-else>
                    {{ $t("label.no") }}
                  </span>
                </b-col>
                <b-col v-if="ofertaDemanda.clientexdel.cliente.pais.hasTasa">
                  <label class="label-form" for="tasa">{{ $t("label.tasa") }}</label>
                  <span
                    v-if="!ofertaDemanda.clientexdel.cliente.pais.hasTasaEnteros"
                    class="data-form"
                    id="tasa"
                  >
                    {{ filterNumber(ofertaDemanda.numTasa, 5) }} %
                  </span>
                  <span
                    v-if="ofertaDemanda.clientexdel.cliente.pais.hasTasaEnteros"
                    class="data-form"
                    id="tasa"
                  >
                    {{ Math.round(ofertaDemanda.numTasa * 100000) }} x 10.000
                  </span>
                </b-col>
              </b-row>
              <b-row class="pl-4 pr-4 pb-3">
                <b-col>
                  <label class="label-form" for="observaciones">
                    {{ $t("label.observaciones") }}
                  </label>
                  <span class="data-form" id="observaciones">
                    {{ ofertaDemanda.observaciones }}
                  </span>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-header>
              <b-card-title class="label-form pl-2 pr-4 pt-3 pb-2">{{ title }}</b-card-title>
              <template v-for="detalleDemanda in ofertaDemanda.detallesDemanda">
                <b-row
                  class="pl-2 pb-3"
                  :key="detalleDemanda.id"
                  v-if="detalleDemanda.cantidadDisponible > 0"
                >
                  <b-col lg="6" md="6">
                    <label class="label-form" :for="`denominacionDemanda_${detalleDemanda.id}`">
                      {{ $t("label.denominacion") }}
                    </label>
                    <span class="data-form" :id="`denominacionDemanda_${detalleDemanda.id}`">
                      {{ detalleDemanda.soCalidadDenominacion.denominacion.codDenominacion }}
                      {{ detalleDemanda.soCalidadDenominacion.desCalidad }}</span
                    >
                  </b-col>
                  <b-col>
                    <label class="label-form" :for="`demandado_${detalleDemanda.id}`">
                      {{ $t("label.demandado") }}
                    </label>
                    <span class="data-form" :id="`demandado_${detalleDemanda.id}`">
                      {{ ofertaDemanda.divisa.simbolo }}
                      {{ filterNumber(detalleDemanda.cantidadDisponible, 2) }}
                    </span>
                  </b-col>
                </b-row>
              </template>
              <template v-for="detalleOferta in ofertaDemanda.detallesOferta">
                <b-row
                  class="pl-2 pb-3"
                  :key="detalleOferta.id"
                  v-if="detalleOferta.cantidadDisponible > 0"
                >
                  <b-col lg="6" md="6">
                    <label class="label-form" :for="`denominacionOferta_${detalleOferta.id}`">
                      {{ $t("label.denominacion") }}
                    </label>
                    <span class="data-form" :id="`denominacionOferta_${detalleOferta.id}`">
                      {{ detalleOferta.soCalidadDenominacion.denominacion.codDenominacion }}
                      {{ detalleOferta.soCalidadDenominacion.desCalidad }}
                    </span>
                  </b-col>
                  <b-col>
                    <label class="label-form" :for="`ofertado_${detalleOferta.id}`">
                      {{ $t("label.ofertado") }}
                    </label>
                    <span class="data-form" :id="`ofertado_${detalleOferta.id}`">
                      {{ ofertaDemanda.divisa.simbolo }}
                      {{ filterNumber(detalleOferta.cantidadDisponible, 2) }}
                    </span>
                  </b-col>
                </b-row>
              </template>
            </b-card-header>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { IOfertaDemanda } from "@/entities";
import VueFilters from "@/vue-filters";
import DelegacionesOpcionales from "@/pages/transferencias/common/DelegacionesOpcionales.vue";

@Component({
  name: "detalle-demanda",
  components: { DelegacionesOpcionales },
  mixins: [VueFilters],
})
export default class OfertaDemandaDetalle extends Vue {
  @Prop({ required: true }) ofertaDemanda!: IOfertaDemanda;
  public fecha = "";
  isShowBankField: boolean | undefined = false;

  mounted(): void {
    this.fecha = this.filterDate(this.ofertaDemanda.fecExpirar!);
    this.isShowBankField = this.ofertaDemanda.clientexdel.cliente.pais.hasInfoBancaria;
  }

  get title(): string {
    return this.ofertaDemanda.cantidadDemandada
      ? this.$t("label.demandas")
      : this.$t("label.ofertas");
  }
  get titleDetalle(): string {
    return this.ofertaDemanda.cantidadDemandada
      ? this.$t("label.detalles.demanda")
      : this.$t("label.detalles.oferta");
  }
}
</script>

<style lang="scss" scoped>
.recent-label {
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 30px;
  letter-spacing: normal;
  color: var(--secundario-prosegur-claro);
}
.label-form {
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  color: var(--secundario-prosegur-oscuro-plus-10);
  margin-bottom: 0;
}
.data-form {
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  color: var(--secundario-prosegur-claro);
  text-transform: initial;
}

.btn-number {
  border-color: transparent;
  background-color: rgba(0, 0, 0, 0.03);
}

.card {
  margin: 0 0 0 0.75rem;
}

.card span {
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 99%;
  overflow: hidden;
}

.card span:hover {
  white-space: normal;
}

.card-body {
  margin: 0;
  padding: 0;
}

.card-header,
.card-text {
  padding: 1rem;
}

.move-panel {
  transition: all 1.5s ease-in-out;
  transform: translate(-25vw, 0);
}
</style>
